import { DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useCalculusTFunction } from '@retail/calculus/i18n';
import { SuspenseWithSentryErrorBoundary } from '@retail/components';
import { ContainedButton, Dialog, TextButton } from '@shared/components';

interface Props {
    open: boolean;
    title: string;
    dialogContent: React.ReactNode;
    isDisabled?: boolean;
    isLoading?: boolean;
    onClose: () => void;
    onSubmit: () => void;
}

export function EditConditionDialog({ open, title, dialogContent, isDisabled, isLoading, onClose, onSubmit }: Props) {
    const t = useCalculusTFunction();
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            sx={{ '& .MuiPaper-root': { minHeight: 400 } }}
        >
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <SuspenseWithSentryErrorBoundary>{dialogContent}</SuspenseWithSentryErrorBoundary>
            </DialogContent>
            <DialogActions>
                <TextButton onClick={onClose}>{t('calculus.cancel')}</TextButton>

                <ContainedButton
                    size="small"
                    color="secondary"
                    disabled={isDisabled}
                    loading={isLoading}
                    onClick={onSubmit}
                >
                    {t('calculus.toApproval')}
                </ContainedButton>
            </DialogActions>
        </Dialog>
    );
}
